export default __webpack_public_path__ + "static/media/01_Kom_Kulturschule.ccc5fe36.jpg";